import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AsyncRequestService } from 'src/app/core/async-request/async-request.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleBusinessProfileService {
  constructor(private httpClient: HttpClient, private asyncRequestService: AsyncRequestService) {}

  getAccounts(companyId, requestId, siteId, code) {
    let params = new HttpParams();
    const appendParam = (key, value) => (value ? (params = params.append(key, value)) : null);
    appendParam('request_id', requestId);
    appendParam('site_id', siteId);
    appendParam('code', code);
    return this.httpClient
      .get(`${environment.apiURLPrefix}/api/1.0/companies/${companyId}/gmb/authorized/accounts`, {
        params,
      })
      .pipe(map((result: any) => result?.accounts));
  }

  connectLocation(companyId: number, data: any) {
    return this.asyncRequestService.post(
      `${environment.apiURLPrefix}/api/1.0/companies/${companyId}/gmb/authorized/finalize`,
      data
    );
  }

  completeAuthorization(companyId: number, data: { site_id: number }) {
    return this.asyncRequestService.post(
      `${environment.apiURLPrefix}/api/1.0/companies/${companyId}/gmb/complete-authorization`,
      data
    );
  }
}
